import {APP} from '../../actions/app/appActionTypes';

const INITIAL_STATE = {
  loading: true,
  buttonLoading: false,
  errorSnack: false,
  errorSnackText: '',
  successSnack: '',
  successSnackText: '',
  popupToShow: '',
  popupToShowData: {},
  additionalPopupShow: '',
  confirmPopup: {
    title: '',
    visible: false,
    text: '',
    confirmCallback: () => {}
  }
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APP.SET_MODAL:
      return {...state, popupToShow: action.payload};
    case APP.SET_MODAL_DATA:
      return {...state, popupToShowData: action.payload};
    case APP.SET_MODAL_ADDITIONAL:
      return {...state, additionalPopupShow: action.payload};
    case APP.CLOSE_MODAL:
      return {...state, popupToShow: action.payload.modal, popupToShowData: {}};
    case APP.CLOSE_MODAL_ADDITIONAL:
      return {...state, additionalPopupShow: action.payload.modal};
    case APP.LOADING:
      return {...state, loading: action.payload};
    case APP.BUTTON_LOADING:
      return {...state, buttonLoading: action.payload};
    case APP.ERROR_SNACK_OPEN:
      return {...state, errorSnack: true, errorSnackText: action.payload};
    case APP.ERROR_SNACK_CLOSE:
      return {...state, errorSnack: false};
    case APP.SUCCESS_SNACK_OPEN:
      return {...state, successSnack: true, successSnackText: action.payload};
    case APP.SUCCESS_SNACK_CLOSE:
      return {...state, successSnack: false};
    case APP.SHOW_CONFIRM_POPUP:
      return {
        ...state,
        confirmPopup: {
          visible: true,
          title: action.payload.title ?? '',
          text: action.payload.text ?? '',
          confirmCallback: action.payload.confirmCallback
        }
      };
    case APP.HIDE_CONFIRM_POPUP:
      return {
        ...state,
        confirmPopup: {
          ...state.confirmPopup,
          visible: false,
          confirmCallback: () => {}
        }
      };
    default:
      return state;
  }
};
